export function isNumeric(str: any) {
  if (typeof str !== 'string') return false;
  return !isNaN((str as unknown) as number) && !isNaN(parseInt(str));
}
